import { FindLeadsResponse } from '@/api/generated/endpoints/leads/leads.zod.ts';
import leadsJson from '@/mocks/leads.json';
import { LeadSchema } from '@/models/entities/lead.ts';

const apiLeads = FindLeadsResponse.parse(leadsJson);
export const mockApiLeads = () => [...apiLeads];
export const mockDomainLeads = () => apiLeads.map((l) => LeadSchema.parse(l));
export const mockLead = () => LeadSchema.parse(apiLeads[0]);
export const mockFullCustomerLead = () => LeadSchema.parse(apiLeads[1]);
export const mockUnknownCustomerLead = () => LeadSchema.parse(apiLeads[6]);
export const mockNameOnlyCustomerLead = () => LeadSchema.parse(apiLeads[0]);
